export default "__VITE_PUBLIC_ASSET__105de6cd__"